import name from './name'

const selectSliceData = state => state[name]

const selectIsLoading = state => selectSliceData(state).isLoading
const selectAvailableBonusMaterials = state => selectSliceData(state).bonusMaterials

export { selectIsLoading, selectAvailableBonusMaterials }
